import { SelectOptionProps } from './types'

export const Option = (props: SelectOptionProps) => {
  return <option {...props} />
}
